/**
 * @prettier
 */
import { createRestaurantMuiTheme, MuiTheme } from 'src/styles/createRestaurantMuiTheme';

export const theme: MuiTheme = createRestaurantMuiTheme();
